/*
  This script is used to refresh the cart when a product is added to the wishlist.
  It is used to update the cart icon bubble and the cart drawer.
  It is also used to update the cart when a product is added to the cart from the wishlist.
*/

document.addEventListener('DOMContentLoaded', function() {
  cartRefresh = async function (){
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (!cart || typeof cart.getSectionsToRender !== 'function') {
      return;
    }
    const sections = cart.getSectionsToRender().map((section) => section.id);
    const sectionString = sections.join(',');
    let response;
    try {
      response = await fetch(`/?sections=${sectionString}`)
        .then(res => res.json());
    } catch (err) {
      return;
    }
    const cartDrawer = document.querySelector('cart-drawer');
    let cartIconBubbleHtml;
    try {
      cartIconBubbleHtml = new DOMParser().parseFromString(response['cart-icon-bubble'], 'text/html').getElementById('shopify-section-cart-icon-bubble').innerHTML;
    } catch (err) {
      return;
    }
    const cartIconBubble = document.getElementById('cart-icon-bubble');
    if (!cartIconBubble) {
      return;
    }
    let cartData;
    try {
      cartData = await fetch('/cart.js').then(res => res.json());
    } catch (err) {
      return;
    }
    if(cartDrawer){
      try {
        const sectionsParam = cartDrawer.getSectionsToRender().map(s => s.id).join(',');
        const cartState = await fetch(`/?sections=${sectionsParam}`)
          .then(res => res.json());
        if (typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents({ sections: cartState, ...cartData });
          cartDrawer.open();
          if (cartData.item_count > 0) {
            cartDrawer.classList.remove('is-empty');
            const drawerItems = cartDrawer.querySelector('cart-drawer-items');
            if (drawerItems) drawerItems.classList.remove('is-empty');
            const innerEmpty = cartDrawer.querySelector('.drawer__inner-empty');
            if (innerEmpty) innerEmpty.style.display = 'none'; // or innerEmpty.remove();
          }
        }
      } catch (err) {
        return;
      }
    }
    cartIconBubble.innerHTML = cartIconBubbleHtml;
    }
    function onSwymLoadCallback(swat) {
    let event = 'sw:addedtocart';
    let listener = function(e) {
    cartRefresh();
    };
    swat.evtLayer.addEventListener(event, listener);
    }
    if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push(onSwymLoadCallback);
});
